import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { environment } from 'src/environments/environment';
import { LoginService } from '../../login/services/login.service';
import { Firmas } from '../models/firmas';
import { IGestionarFirmasService } from './ports/i-gestionar-firmas-service';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { ResumenEstados } from '../models/resumen-inicial';
import { GetFirmasPageResult } from '../models/get-firmas-page-result';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { FormulariosInfo145, FormulariosInfo145Response } from '../models/formulariosInfo145';

@Injectable({
  providedIn: 'root'
})
export class GestionaFirmasApiService implements IGestionarFirmasService {

  firmas: Firmas[]; // = [];
  resumenHome: any;

  private readonly URL_GET_FIRMAS: string = `${environment.ApiUrlV3}api/Firmas/GetFirmas`;
  private readonly URL_GET_RESUMEN_ESTADOS: string = `${environment.ApiUrlV3}api/Firmas/GetResumenEstados/true`;
  private readonly URL_GET_DESPLEGABLES_FIRMAS: string = `${environment.ApiUrlV3}api/Firmas/GetDesplegables`;
  private readonly URL_GET_RESUMEN_ESTADOS_INICIAL: string = `${environment.ApiUrlV3}api/Firmas/GetResumenEstadosInicial`;
  private readonly URL_GET_DATOS_FORMULARIOS: string = `${environment.ApiUrlV3}api/Firmas/GetDatosFomulariosResumen`;
  private readonly URL_GET_FORMULARIOS_EXCEL: string = `${environment.ApiUrlV3}api/Firmas/GetFormularios`;
  private readonly URL_GET_DATOS_FORMULARIOS_MOCK: string = `${environment.ApiDatosFormulariosMock}`;
  private readonly centroEmpresaSeparator = '||';

  constructor(private client: HttpClient,
    private endpointSerivce: EndpointService,
    private loginService: LoginService,
    private conversionDatosApiService: ConversionDatosApiService) { }

  GetFirmas(filtrosFirmas: FiltroSqp[], pageNumber: number, pageSize: number = 100, orden: OrdenColumna = { campoOrden: '', orden: '' }, refresh?: boolean): Observable<GetFirmasPageResult> {
    let url = this.endpointSerivce.UrlGetFirmas.replace('{todos}', 'true');

    const { empresas: filtrosEmpresa, centros: filtrosCentro } = this.resolverFiltrosEmpresaCentro(filtrosFirmas);
    let filtrosTipoDosier = filtrosFirmas.find(x => x.titulo == 'Tipo dosier')?.valoresSeleccionados?.listaValores?.join(';');
    let filtroFromEnvio = this.formatFechaFiltro(filtrosFirmas.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToEnvio = this.formatFechaFiltro(filtrosFirmas.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaHasta);
    let filtroFromContrato = this.formatFechaFiltro(filtrosFirmas.find(x => x.titulo == 'Fecha contrato')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToContrato = this.formatFechaFiltro(filtrosFirmas.find(x => x.titulo == 'Fecha de contrato')?.valoresSeleccionados?.valorFechaHasta);
    let filtroEstado = this.conversionDatosApiService.conversionEstadoSalida(filtrosFirmas.find(x => x.titulo == 'Estado')?.valoresSeleccionados?.valorString);
    let filtroNuevo = filtrosFirmas.find(x => x.titulo == 'Nuevos')?.valoresSeleccionados?.valorBool;
    let filtroSandbox = filtrosFirmas.find(x => x.titulo == 'Sandbox')?.valoresSeleccionados?.valorBool;
    let filtroBuscar = filtrosFirmas.find(x => x.titulo == 'Buscar')?.valoresSeleccionados?.valorString;
    //console.log('filtrofirmas: ', filtrosFirmas);

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
        .set('pageNumber', pageNumber)
        .set('pageSize', pageSize)
        .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
        .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
        .set('fechaDesdeC', filtroFromContrato ? filtroFromContrato : '')
        .set('fechaHastaC', filtroToContrato ? filtroToContrato : '')
        .set('filtros[CODIGOEMPRESA]', filtrosEmpresa.length ? filtrosEmpresa.join(',') : '')
        .set('filtros[CODIGOCENTRO]', filtrosCentro.length ? filtrosCentro.join(',') : '')
        .set('filtros[TIPOENVIO]', filtrosTipoDosier ? filtrosTipoDosier : '')
        .set('filtros[EstadoString]', filtroEstado ? filtroEstado : '')
        .set('filtroNuevos', filtroNuevo ? filtroNuevo : false)
        .set('filtroSandbox', filtroSandbox ? filtroSandbox : false)
        .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }

    //si fechaFirma y orden desc, se elimina el orden ya que ya lo hace el back por defecto
    if (orden.campoOrden == 'fechaFirma' && orden.orden == 'desc') orden = { campoOrden: '', orden: '' };

    if (orden.campoOrden) {
      httpOptions.params = httpOptions.params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
    }

    return this.client.get(url, httpOptions).pipe(
      map((response: any) => {
        const data = response.Data ?? [];
        const hasMore = response.HasMore !== undefined
          ? response.HasMore === true
          : pageSize > 0 && data.length >= pageSize;
        const result: GetFirmasPageResult = {
          data,
          hasMore,
          pageNumber: response.PageNumber ?? pageNumber
        };
        this.firmas = data;
        return result;
      })
    );
  }

  GetInfoDocs(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = this.endpointSerivce.UrlFirmaGetDocumentos;
    url = url.includes('{idFirma}') ? url.replace('{idFirma}', this.firmas[index].idFirma.toString()) : `${url}/${this.firmas[index].idFirma.toString()}`;
    //CARGAMOS LOS DOCUMETNOS
    return this.client.get(url, httpOptions).pipe(
      map((response: any) => {
        return JSON.parse(response.Data)
      }))

  }

  GetInfoEventos(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = this.endpointSerivce.UrlFirmaGetEventos;
    url = url.includes('{idFirma}') ? url.replace('{idFirma}', this.firmas[index].idFirma.toString()) : `${url}/${this.firmas[index].idFirma.toString()}`;

    return this.client.get(url, httpOptions).pipe(
      map((response: any) => {
        return JSON.parse(response.Data);
      }))
  }

  GetInfoTipoDocs(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = this.endpointSerivce.UrlFirmaGetTiposDocumentos;
    url = url.includes('{idFirma}') ? url.replace('{idFirma}', this.firmas[index].idFirma.toString()) : `${url}/${this.firmas[index].idFirma.toString()}`;

    return this.client.get(url, httpOptions).pipe(
      map((response: any) => {
        return JSON.parse(response.Data);
      }))
  }

  BorrarFirmas(ids: number[]): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token
      }),
      body: ids,
    };
    return this.client.delete(this.endpointSerivce.UrlEliminaFirmas, options).pipe(
      map((response: any) => {
        if (response.Ok) return JSON.parse(response.Data);
        else throw new Error(response);
      })
    );
  }

  BorrarFirma(idFirma: number): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.delete(this.endpointSerivce.UrlFirmaElimina.replace('{idFirma}', idFirma.toString()), options).pipe(
      map((response: any) => {
        if (response.Ok) return "Firma eliminada correctamente";
        else throw new Error(response);
      })
    );
  }

  CancelarFirma(idFirma: number): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post(this.endpointSerivce.UrlFirmaCancela.replace('{idFirma}', idFirma.toString()), null, options).pipe(
      map((response: any) => {
        if (response.Ok) return "Firma cancelada correctamente";
        else throw new Error(`No se ha podido cancelar la firma por un error interno de Signaturit: ${response.Message}`);
      })
    );
  }

  DescargaFirmaCompleta(id: any): Observable<string> {


    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token
      })
    }; return this.client.get(this.endpointSerivce.UrlDescargarFirmas.replace('{id}', id.toString()), options).pipe(
      map((response: any) => {
        if (response == null) throw new Error("No se han encontrado ficheros disponibles para descargar");
        // Recuperamos el fichero en formato base64 string y obtenemos el array de bytes
        return atob(response.Data);
      }))
  }

  cargarResumenHome(filtrosSqp: FiltroSqp[]): Observable<any> {
    let filtroFromEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaHasta);

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token,
      }),
      params: new HttpParams()
        .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
        .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
    };
    return this.client.get(this.URL_GET_RESUMEN_ESTADOS_INICIAL, httpOptions).pipe(
      map((response: any) => {
        return this.resumenHome = response;
      })
    )
  }

  getResumenEstados(filtrosSqp: FiltroSqp[]): Observable<ResumenEstados[]> {

    const { empresas: filtrosEmpresa, centros: filtrosCentro } = this.resolverFiltrosEmpresaCentro(filtrosSqp);
    let filtrosTipoDosier = filtrosSqp.find(x => x.titulo == 'Tipo dosier')?.valoresSeleccionados?.listaValores?.join(';');
    let filtroFromEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaHasta);
    let filtroFromContrato = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha contrato')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToContrato = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha contrato')?.valoresSeleccionados?.valorFechaHasta);
    let filtroNuevo = filtrosSqp.find(x => x.titulo == 'Nuevos')?.valoresSeleccionados?.valorBool;
    let filtroSandbox = filtrosSqp.find(x => x.titulo == 'Sandbox')?.valoresSeleccionados?.valorBool;
    let filtroBuscar = filtrosSqp.find(x => x.titulo == 'Buscar')?.valoresSeleccionados?.valorString;

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
        .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
        .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
        .set('fechaDesdeC', filtroFromContrato ? filtroFromContrato : '')
        .set('fechaHastaC', filtroToContrato ? filtroToContrato : '')
        .set('filtros[CODIGOEMPRESA]', filtrosEmpresa.length ? filtrosEmpresa.join(',') : '')
        .set('filtros[CODIGOCENTRO]', filtrosCentro.length ? filtrosCentro.join(',') : '')
        .set('filtros[TIPOENVIO]', filtrosTipoDosier ? filtrosTipoDosier : '')
        .set('filtroNuevos', filtroNuevo ? filtroNuevo : false)
        .set('filtroSandbox', filtroSandbox ? filtroSandbox : false)
        .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }
    return this.client.get(this.URL_GET_RESUMEN_ESTADOS, httpOptions).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  getDesplegablesFiltros(): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      })
    };
    return this.client.get(`${this.URL_GET_DESPLEGABLES_FIRMAS}`, httpOptions).pipe(
      map((response: any) => {
        return response
      })
    );
  }

  getDatosFormularios(filtrosSqp: FiltroSqp[]): Observable<void | any[]> {

    const { empresas: filtrosEmpresa, centros: filtrosCentro } = this.resolverFiltrosEmpresaCentro(filtrosSqp);
    let filtrosTipoDosier = filtrosSqp.find(x => x.titulo == 'Tipo dosier')?.valoresSeleccionados?.listaValores?.join(';');
    let filtroFromEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaHasta);
    let filtroFromContrato = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha contrato')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToContrato = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de contrato')?.valoresSeleccionados?.valorFechaHasta);
    let filtroEstado = this.conversionDatosApiService.conversionEstadoSalida(filtrosSqp.find(x => x.titulo == 'Estado')?.valoresSeleccionados?.valorString);
    let filtroNuevo = filtrosSqp.find(x => x.titulo == 'Nuevos')?.valoresSeleccionados?.valorBool;
    let filtroSandbox = filtrosSqp.find(x => x.titulo == 'Sandbox')?.valoresSeleccionados?.valorBool;
    let filtroBuscar = filtrosSqp.find(x => x.titulo == 'Buscar')?.valoresSeleccionados?.valorString;

    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
        .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
        .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
        .set('fechaDesdeC', filtroFromContrato ? filtroFromContrato : '')
        .set('fechaHastaC', filtroToContrato ? filtroToContrato : '')
        .set('filtros[CODIGOEMPRESA]', filtrosEmpresa.length ? filtrosEmpresa.join(',') : '')
        .set('filtros[CODIGOCENTRO]', filtrosCentro.length ? filtrosCentro.join(',') : '')
        .set('filtros[TIPOENVIO]', filtrosTipoDosier ? filtrosTipoDosier : '')
        .set('filtros[EstadoString]', filtroEstado ? filtroEstado : '')
        .set('filtroNuevos', filtroNuevo ? filtroNuevo : false)
        .set('filtroSandbox', filtroSandbox ? filtroSandbox : false)
        .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
    }

    return this.client.get(`${this.URL_GET_DATOS_FORMULARIOS}/true`, httpOptions).pipe(
      map((response: any) => {
        return this.conversionDatosApiService.mapFormulariosInfoEntrada(response);
      }),
      catchError((error) => {
        console.error(error);
        return throwError(error);
      })
    );
  }


  getFormulariosExcel(filtrosSqp: FiltroSqp[], objetoFormularios: FormulariosInfo145[]): Observable<FormulariosInfo145Response[]> {

    const { empresas: filtrosEmpresa, centros: filtrosCentro } = this.resolverFiltrosEmpresaCentro(filtrosSqp);
    let filtrosTipoDosier = filtrosSqp.find(x => x.titulo == 'Tipo dosier')?.valoresSeleccionados?.listaValores?.join(';');
    let filtroFromEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToEnvio = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de envío')?.valoresSeleccionados?.valorFechaHasta);
    let filtroFromContrato = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha contrato')?.valoresSeleccionados?.valorFechaDesde);
    let filtroToContrato = this.formatFechaFiltro(filtrosSqp.find(x => x.titulo == 'Fecha de contrato')?.valoresSeleccionados?.valorFechaHasta);
    let filtroEstado = this.conversionDatosApiService.conversionEstadoSalida(filtrosSqp.find(x => x.titulo == 'Estado')?.valoresSeleccionados?.valorString);
    let filtroNuevo = filtrosSqp.find(x => x.titulo == 'Nuevos')?.valoresSeleccionados?.valorBool;
    let filtroSandbox = filtrosSqp.find(x => x.titulo == 'Sandbox')?.valoresSeleccionados?.valorBool;
    let filtroBuscar = filtrosSqp.find(x => x.titulo == 'Buscar')?.valoresSeleccionados?.valorString;
    const idDocumentoVersion = objetoFormularios
      ?.map((x) => `${x.idTipoDocumento}-${x.version}`)
      .join(',') ?? '';
    const httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": `Bearer ${this.loginService.getUserLocalStorage().Token.Token}`
      }),
      params: new HttpParams()
        .set('fechaDesde', filtroFromEnvio ? filtroFromEnvio : '')
        .set('fechaHasta', filtroToEnvio ? filtroToEnvio : '')
        .set('fechaDesdeC', filtroFromContrato ? filtroFromContrato : '')
        .set('fechaHastaC', filtroToContrato ? filtroToContrato : '')
        .set('filtros[CODIGOEMPRESA]', filtrosEmpresa.length ? filtrosEmpresa.join(',') : '')
        .set('filtros[CODIGOCENTRO]', filtrosCentro.length ? filtrosCentro.join(',') : '')
        .set('filtros[TIPOENVIO]', filtrosTipoDosier ? filtrosTipoDosier : '')
        .set('filtros[EstadoString]', filtroEstado ? filtroEstado : '')
        .set('filtroNuevos', filtroNuevo ? filtroNuevo : false)
        .set('filtroSandbox', filtroSandbox ? filtroSandbox : false)
        .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
        .set('idDocumentoVersion', idDocumentoVersion)
    };

    return this.client.get(`${this.URL_GET_FORMULARIOS_EXCEL}/true`, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
        console.error(error);
        return throwError(error);
      })
    );
  }

  private resolverFiltrosEmpresaCentro(filtros: FiltroSqp[]): { empresas: string[], centros: string[] } {
    const empresasSeleccionadas = (filtros.find(x => x.titulo == 'Empresa')?.valoresSeleccionados?.listaValores ?? [])
      .map((codigo) => this.normalizarCodigo(codigo))
      .filter((codigo): codigo is string => !!codigo);

    const centrosSeleccionados = filtros.find(x => x.titulo == 'Centro')?.valoresSeleccionados?.listaValores ?? [];
    const paresCentroEmpresa = centrosSeleccionados
      .map((centroCompuesto) => this.descomponerCentroCompuesto(centroCompuesto))
      .filter((par): par is { codigoEmpresa: string, codigoCentro: string } => !!par?.codigoEmpresa && !!par?.codigoCentro);

    if (!empresasSeleccionadas.length && !paresCentroEmpresa.length) {
      return { empresas: [], centros: [] };
    }

    if (!paresCentroEmpresa.length) {
      return { empresas: empresasSeleccionadas, centros: [] };
    }

    const centrosCompuestos = this.construirCentrosCompuestos(paresCentroEmpresa);

    return {
      empresas: empresasSeleccionadas,
      centros: centrosCompuestos
    };
  }

  private construirCentrosCompuestos(
    paresCentroEmpresa: { codigoEmpresa: string, codigoCentro: string }[]
  ): string[] {
    return Array.from(new Set(
      paresCentroEmpresa.map((par) => `${par.codigoEmpresa}${this.centroEmpresaSeparator}${par.codigoCentro}`)
    ));
  }

  private descomponerCentroCompuesto(centroCompuesto: string): { codigoEmpresa: string, codigoCentro: string } | null {
    const partes = (centroCompuesto ?? '').split(this.centroEmpresaSeparator);
    if (partes.length > 1) {
      const codigoEmpresa = this.normalizarCodigo(partes[0]);
      const codigoCentro = this.normalizarCodigo(partes[1]);
      if (!codigoCentro) return null;
      return { codigoEmpresa: codigoEmpresa ?? '', codigoCentro };
    }

    const codigoCentro = this.normalizarCodigo(centroCompuesto);
    return codigoCentro ? { codigoEmpresa: '', codigoCentro } : null;
  }

  private normalizarCodigo(codigo: string | number | null | undefined): string | null {
    if (codigo === null || codigo === undefined) return null;
    const normalizado = `${codigo}`.trim();
    return normalizado.length ? normalizado : null;
  }

  /** Serializa fechas de filtro en hora local (sin Z), alineado con el día de calendario del grid. */
  private formatFechaFiltro(fecha: Date | null | undefined): string {
    if (!fecha) return '';
    const y = fecha.getFullYear();
    const m = String(fecha.getMonth() + 1).padStart(2, '0');
    const d = String(fecha.getDate()).padStart(2, '0');
    const hh = String(fecha.getHours()).padStart(2, '0');
    const mm = String(fecha.getMinutes()).padStart(2, '0');
    const ss = String(fecha.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d}T${hh}:${mm}:${ss}`;
  }


}
